import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import TelegramIcon from "@mui/icons-material/Telegram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PinterestIcon from "@mui/icons-material/Pinterest";
import RedditIcon from "@mui/icons-material/Reddit";

import AppleIcon from "@mui/icons-material/Apple";
import CropPortraitIcon from "@mui/icons-material/CropPortrait";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAmilia,
  faAppStore,
  faDiscord,
  faGoogle,
  faGooglePlay,
  faQuora,
  faThreads,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { faIdCard, faStar } from "@fortawesome/free-regular-svg-icons";
import SellIcon from "@mui/icons-material/Sell";
import { Box } from "@mui/material";
import { theme } from "../views/App";

export const returnLogo = (item) => {
  if (item === "Twitter") {
    return (
      <>
        <span title="Twitter">
          {/* <TwitterIcon style={{ width: 15 }} /> */}

          <FontAwesomeIcon
            icon={faXTwitter}
            style={{ width: 15 }}
          ></FontAwesomeIcon>
        </span>
      </>
    );
  } else if (item === "Facebook") {
    return (
      <>
        <span title="Facebook">
          <FacebookIcon style={{ width: 15 }} />{" "}
        </span>
      </>
    );
  } else if (item === "Pinterest") {
    return (
      <span title="Pinterest">
        <PinterestIcon style={{ width: 15 }} />{" "}
      </span>
    );
  } else if (item === "Threads") {
    return (
      <span title="Threads">
        <FontAwesomeIcon
          icon={faThreads}
          style={{ width: 15 }}
        ></FontAwesomeIcon>
      </span>
    );
  } else if (item === "Discord") {
    return (
      <span title="Discord">
        <FontAwesomeIcon
          icon={faDiscord}
          style={{ width: 15 }}
        ></FontAwesomeIcon>
      </span>
    );
  } else if (item === "Reddit") {
    return (
      <span title="Reddit">
        <RedditIcon style={{ width: 15 }} />{" "}
      </span>
    );
  } else if (item === "Indeed") {
    return (
      <span title="Indeed">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          width="15px"
          height="15px"
          fill={theme.palette.primary.main}
        >
          <path d="M 18.5 2 C 10.75 2 6 11.25 6 16 C 6 16 9.25 4 19 4 C 22.625 4 25 6 25 6 C 25 6 24 2 18.5 2 z M 17.5 7 A 3.5 3.5 0 1 0 17.5 14 A 3.5 3.5 0 1 0 17.5 7 z M 20 16 C 20 16 19 17 15 17 L 15 27.5 C 15 28.881 16.119 30 17.5 30 C 18.881 30 20 28.881 20 27.5 L 20 16 z" />
        </svg>
      </span>
    );
  } else if (item === "Playstore") {
    return (
      <>
        <span title="Playstore">
          <FontAwesomeIcon
            icon={faGooglePlay}
            style={{ width: 15 }}
          ></FontAwesomeIcon>
        </span>
      </>
    );
  } else if (item === "Instagram") {
    return (
      <>
        <span title="Instagram">
          <InstagramIcon style={{ width: 15 }} />{" "}
        </span>
      </>
    );
  } else if (item === "Youtube") {
    return (
      <>
        <span title="Youtube">
          <YouTubeIcon style={{ color: "red" }} />
        </span>
      </>
    );
  } else if (item === "Whatsapp") {
    return (
      <>
        <span title="Whatsapp">
          <WhatsAppIcon style={{ width: 15 }} />{" "}
        </span>
      </>
    );
  } else if (item === "Email") {
    return (
      <>
        <span title="Email">
          <EmailIcon style={{ width: 15 }} />{" "}
        </span>
      </>
    );
  } else if (item === "Telegram") {
    return (
      <>
        <span title="Telegram">
          <TelegramIcon style={{ width: 15 }} />
        </span>
      </>
    );
  } else if (item === "Linked In") {
    return (
      <>
        <span title="Linked In">
          <LinkedInIcon style={{ width: 15 }} />
        </span>
      </>
    );
  } else if (item === "Appstore") {
    return (
      <>
        <span title="Appstore">
          <FontAwesomeIcon
            icon={faAppStore}
            style={{ width: 15 }}
          ></FontAwesomeIcon>
        </span>
      </>
    );
  } else if (item === "Quora") {
    return (
      <span title="Quora">
        <FontAwesomeIcon icon={faQuora} style={{ width: 15 }}></FontAwesomeIcon>
      </span>
    );
  } else if (item === "Glassdoor") {
    return (
      <>
        <span title="Glassdoor">
          <CropPortraitIcon style={{ width: 15 }} />{" "}
        </span>
      </>
    );
  } else if (item === "Ambition Box") {
    return (
      <span title="Ambition Box">
        <FontAwesomeIcon
          icon={faAmilia}
          style={{ width: 15 }}
        ></FontAwesomeIcon>
      </span>
    );
  } else if (item === "GMB") {
    return (
      <span title="GMB">
        <FontAwesomeIcon
          icon={faGoogle}
          style={{ width: 15 }}
        ></FontAwesomeIcon>
      </span>
    );
  } else if (item === "Trust Pilot") {
    return (
      <span title="Trust Pilot">
        <FontAwesomeIcon icon={faStar} style={{ width: 15 }}></FontAwesomeIcon>
      </span>
    );
  } else if (item === "None") {
    return (
      <span title="None">
        <FontAwesomeIcon
          icon={faIdCard}
          style={{ width: 15 }}
        ></FontAwesomeIcon>
      </span>
    );
  } else {
    return null;
  }
};

export const RowIcons = (item) => {
  if (item.params.platform === "Twitter") {
    return (
      <>
        <>
          <FontAwesomeIcon
            icon={faXTwitter}
            style={{ width: "12px", marginRight: 5 }}
          ></FontAwesomeIcon>
          <span className="text-wrap">{item.params.description[1]}</span>
        </>
      </>
    );
  } else if (item.params.platform === "Facebook") {
    return (
      <>
        <FacebookIcon style={{ width: "12px", marginRight: 5 }} />
        <span className="text-wrap">{item.params.description[1]}</span>
      </>
    );
  } else if (item.params.platform === "Playstore") {
    return (
      <>
        <FontAwesomeIcon
          icon={faGooglePlay}
          style={{ width: "12px", marginRight: 5 }}
        ></FontAwesomeIcon>
        <span className="text-wrap">{item.params.description[1]}</span>
      </>
    );
  } else if (item.params.platform === "Instagram") {
    return (
      <>
        <InstagramIcon style={{ width: "12px", marginRight: 5 }} />
        <span className="text-wrap">{item.params.description[1]}</span>
      </>
    );
  } else if (item.params.platform === "Youtube") {
    return (
      <>
        <YouTubeIcon style={{ width: "12px", marginRight: 5 }} />
        <span className="text-wrap">{item.params.description[1]}</span>
      </>
    );
  } else if (item.params.platform === "Whatsapp") {
    return (
      <>
        <WhatsAppIcon style={{ width: "12px", marginRight: 5 }} />
        <span className="text-wrap">{item.params.description[1]}</span>
      </>
    );
  } else if (item.params.platform === "Email") {
    return (
      <>
        <EmailIcon style={{ width: "12px", marginRight: 5 }} />
        <span className="text-wrap">{item.params.description[1]}</span>
      </>
    );
  } else if (item.params.platform === "Telegram") {
    return (
      <>
        <TelegramIcon style={{ width: "12px", marginRight: 5 }} />
        <span className="text-wrap">{item.params.description[1]}</span>
      </>
    );
  } else if (item.params.platform === "Linked In") {
    return (
      <>
        <LinkedInIcon style={{ width: "12px", marginRight: 5 }} />
        <span className="text-wrap">{item.params.description[1]}</span>
      </>
    );
  } else if (item.params.platform === "Appstore") {
    return (
      <>
        <AppleIcon style={{ width: "12px", marginRight: 5 }} />
        <span className="text-wrap">{item.params.description[1]}</span>
      </>
    );
  } else if (item.params.platform === "Quora") {
    return (
      <>
        <FontAwesomeIcon
          icon={faQuora}
          style={{ width: "12x", marginRight: 5 }}
        ></FontAwesomeIcon>
        <span className="text-wrap">{item.params.description[1]}</span>
      </>
    );
  } else if (item.params.platform === "Glassdoor") {
    return (
      <>
        <CropPortraitIcon style={{ width: "12px", marginRight: 5 }} />
        <span className="text-wrap">{item.params.description[1]}</span>
      </>
    );
  } else if (item.params.platform === "Ambition Box") {
    return (
      <>
        <FontAwesomeIcon
          icon={faAmilia}
          style={{ width: "10px", marginRight: 5 }}
        ></FontAwesomeIcon>
        <span className="text-wrap">{item.params.description[1]}</span>
      </>
    );
  } else if (item.params.platform === "GMB") {
    return (
      <>
        <FontAwesomeIcon
          icon={faGoogle}
          style={{ width: "10px", marginRight: 5 }}
        ></FontAwesomeIcon>
        <span className="text-wrap">{item.params.description[1]}</span>
      </>
    );
  } else if (item.params.platform === "None") {
    return (
      <>
        <FontAwesomeIcon
          icon={faIdCard}
          style={{ width: "10px", marginRight: 5 }}
        ></FontAwesomeIcon>
        <span className="text-wrap">{item.params.description[1]}</span>
      </>
    );
  }
};

export const returnColor = (color) => {
  return (
    <Box
      width={10}
      height={10}
      borderRadius="50%"
      sx={{
        backgroundColor: `${color}`,
      }}
    ></Box>
  );
};
